module.exports = __webpack_public_path__ + "static/img/loginImg.986e4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginSuihua/img/loginImg.png
// module id = e/Gf
// module chunks = 183